import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import CoinChartPrice from './components/CoinPriceChart';
import FAQ from './components/FAQ';
import {withTranslation} from "react-i18next";
import AssetHistoryChart from "./components/AssetHistoryChart";
import {connect} from "react-redux";
import Rewards from "./components/Rewards";

const WalletPage = ({t, steemAccount}) => (
  <Container className="dashboard">

    <Row>
      <Col md={12}>
        <h3 className="page-title">{t('wallet.title')}</h3>
      </Col>

      <Col md={9}>
        <Row>
          <Col md={4}>
            <CoinChartPrice
              name="BTC"
              identificator="btc"
              fill="#6faae1"
              stroke="#6faae1"
            />
          </Col>

          <Col md={4}>
            <CoinChartPrice
              name="HIVE"
              identificator="hive"
              fill="#f198ca"
              stroke="#f198ca"
            />
          </Col>

          <Col md={4}>
            <CoinChartPrice
              name="HBD"
              identificator="hbd"
              fill="#4ce1b6"
              stroke="#4ce1b6"
            />
          </Col>

        </Row>
        <Row>
          <Col>
            <AssetHistoryChart name={'Hive power'} color="#6faae1" values={steemAccount.walletHistory.hive_power} />
            <AssetHistoryChart name={'HIVE'} color="#f198ca" values={steemAccount.walletHistory.hive} />
            <AssetHistoryChart name={'HBD'} color="#4ce1b6" values={steemAccount.walletHistory.hbd} />
          </Col>
        </Row>
      </Col>

      <Col md={3}>

        {/*<Row>*/}
        {/*  <BalanceRadar account={steemAccount}/>*/}
        {/*</Row>*/}
        <Row>
          <Rewards/>
          <FAQ />
        </Row>
      </Col>
    </Row>

  </Container>
);

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    steemAccount: state.steemAccount
  }
}
export default connect(mapStateToProps)(withTranslation('dashboard')(WalletPage));
